
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function PaymentSection() {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Acesso à Plataforma</CardTitle>
        <CardDescription>
          Informações sobre seu acesso à plataforma
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="border rounded-lg p-4">
          <p className="font-medium mb-2">Status</p>
          <div className="flex items-center">
            <span className="text-sm inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
              Ativo
            </span>
          </div>
        </div>
        
        <div className="border rounded-lg p-4">
          <p className="font-medium">Acesso</p>
          <div className="flex justify-between items-center mt-2">
            <div>
              <p className="text-lg font-bold">Acesso Completo</p>
              <p className="text-sm text-gray-500">Acesso a todos os recursos</p>
            </div>
          </div>
        </div>

        <div className="text-sm text-gray-500 mt-4">
          O sistema de assinaturas foi removido. Todos os usuários têm acesso completo.
        </div>
      </CardContent>
    </Card>
  );
}
